<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ detailInfo.projectName }}</td>
						<th>项目编号</th>
						<td>{{ detailInfo.projectCode }}</td>
						<th>项目地址</th>
						<td>{{ detailInfo.projectAddress }}</td>
					</tr>
					<tr>
						<th>建设单位</th>
						<td>{{ detailInfo.companyName }}</td>
						<th>建设单位组织机构代码</th>
						<td>{{ detailInfo.companyCode }}</td>
						<th>发生所在省</th>
						<td>{{ detailInfo.province }}</td>
					</tr>
					<tr>
						<th>发生所在市</th>
						<td>{{ detailInfo.city }}</td>
						<th>奖励简介</th>
						<td>{{ detailInfo.awardIntro }}</td>
						<th>表彰文号</th>
						<td>{{ detailInfo.commendCode }}</td>
					</tr>
					<tr>
						<th>奖励日期</th>
						<td>{{ detailInfo.awardDate }}</td>
						<th>奖励决定内容</th>
						<td>{{ detailInfo.awardContent }}</td>
						<th>奖励部门</th>
						<td>{{ detailInfo.awardDept }}</td>
					</tr>
					<tr>
						<th>奖励部门级别</th>
						<td>{{ detailInfo.awardDeptGrade }}</td>
						<th>登记部门</th>
						<td>{{ detailInfo.registerDept }}</td>
						<th>登记部门联系电话</th>
						<td>{{ detailInfo.registerDeptPhone }}</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { getCompanyBehaviorDetail, getCompanyWarningDetail } from '@/api/qualificationQuery/company'
	// 良好行为详情
	export default {
		name: 'GoodBehaviorDetail',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			},
			// 表示是否是资质宝风险提醒
			isRisk: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				detailInfo: {},
				isVip: false,
				isSVip: false
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			if (this.isRisk) {
				this.getRiskBehaviorDetail()
			} else {
				this.initDetail()
			}
		},
		methods: {
			initDetail() {
				this.loading = true
				const params = {
					companyBehaviorId: this.id
				}
				getCompanyBehaviorDetail(params)
					.then(res => {
						const { data, code, message } = res
						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								this.detailInfo = data
							}
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			},

			// 获取资质宝风险提醒关于企业的不良行为详情
			getRiskBehaviorDetail() {
				this.loading = true
				const params = {
					companyBehaviorId: this.id
				}

				getCompanyWarningDetail(params)
					.then(response => {
						const { data } = response
						if (data) {
							this.detailInfo = data
						}
						this.loading = false
					})
					.catch(err => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
